

















import { Prop, Component, Vue } from "vue-property-decorator";
import Action from "@/models/action";
import ProjectTemplate from "@/models/project-template";
import VToolbar from "../components/VToolbar.vue";
import VIconEdit from "../components/icons/VIconEdit.vue";

@Component({
  components: {
    VIconEdit,
    VToolbar
  }
})
export default class PlanList extends Vue {
  @Prop({ default: () => [] }) templates!: ProjectTemplate[];
  @Prop({ default: () => [] }) actions!: Action[];

  get plans() {
    return this.templates.map(t => ({
      id: t.id,
      title: t.title,
      to: { name: "plan-edit", params: { id: t.id } }
    }));
  }
}
